import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import useFleet from '../../hooks/useFleet'
import AppRoutes from '../../routes/appRoutes'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import MainHeading from '../../components/MainHeading/MainHeading'
import Button from '../../components/Button/Button'
import useIntercom from '../../hooks/useIntercom'
import FleetTable from './components/FleetTable'
import PropTypes from 'prop-types'
import { useNetworkStatus } from '../../utils/networkStatus'
import ButtonWithTooltip from '../../components/ButtonWithTooltip/ButtonWithTooltip'

const FleetPage = () => {
    const { fleetFilters, saveFleetFilters } = useFleet()
    const { isOffline } = useNetworkStatus()
    const { loadIntercom, intercomSendMessage } = useIntercom()
    const [removeAssetsEnabled, setRemoveAssetsEnabled] = useState(false)
    const [assetsToRemove, setAssetsToRemove] = useState([])

    useEffect(() => {
        if (!isOffline) {
            loadIntercom()
        } else {
            if (window.Intercom) {
                window.Intercom('shutdown')
            }
        }
        return () => {
            let current = JSON.parse(JSON.stringify(fleetFilters))
            current.query = ''
            saveFleetFilters(current)
        }
    }, [isOffline])

    const handleToggleRemoveAssetsEnabled = () => {
        setRemoveAssetsEnabled(prevState => !prevState)
    }

    const renderActions = () => {
        if (removeAssetsEnabled) {
            return [
                <Button
                    key="removeAsset"
                    onClick={handleToggleRemoveAssetsEnabled}
                    text="Cancel"
                    variant="tertiary"
                    className="text-sm font-normal md:w-auto w-full flex-grow"
                />,
                <Button
                    key="removeAssetsConfirm"
                    text="Remove Assets"
                    disabled={assetsToRemove?.length === 0}
                    variant="primary"
                    className="text-sm font-normal md:w-auto w-full flex-grow"
                    onClick={() => {
                        const message = `These assets are no longer in my fleet: ${assetsToRemove
                            .map(item => item?.equipmentNumber)
                            .join(', ')}`

                        intercomSendMessage(message)

                        handleToggleRemoveAssetsEnabled()
                    }}
                />,
            ]
        }

        return [
            <ButtonWithTooltip
                key="removeAsset"
                onClick={handleToggleRemoveAssetsEnabled}
                text="Remove Assets"
                variant="tertiary"
                className="text-sm font-normal md:w-auto w-full flex-grow"
                disabled={isOffline}
                isOffline={isOffline}
            />,
            <Link
                key="addAssetLink"
                to={{
                    pathname: AppRoutes.createAsset(),
                    state: {
                        source: AppRoutes.fleet(),
                    },
                }}
            >
                <ButtonWithTooltip
                    text="Add Asset"
                    variant="primary"
                    className="text-sm font-normal md:w-auto w-full flex-grow"
                    disabled={isOffline}
                    isOffline={isOffline}
                />
            </Link>,
        ]
    }

    return (
        <ContentLayout>
            <MainHeading
                title={removeAssetsEnabled ? 'Remove Asset' : 'Fleet'}
                actions={renderActions()}
            />
            <div className="w-full flex-grow lg:px-6 px-0 lg:py-8 py-0">
                <FleetTable
                    selectable={removeAssetsEnabled}
                    onSelectItems={setAssetsToRemove}
                    selectedItems={assetsToRemove}
                    singleSelection={false}
                />
            </div>
        </ContentLayout>
    )
}

FleetPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
}

export default FleetPage
